import { getCTAOuterTemplate } from "../../shortcodes/templates";
import { addShortcodeToEditor, getShortcodeWrapper } from "@/assets/utilities/tinymce/shortodeAddition";

const ctaOuterConfig = (tinymce, uuid, shortcodeOnClick) => {
  tinymce.activeEditor.windowManager.open({
    title: "CTA Outer Button",
    body: {
      type: "panel",
      items: [
        {
          type: "input",
          name: "text",
          label: "Button text",
          placeholder: "Button text",
        },
        {
          type: "input",
          name: "url",
          label: "URL",
          placeholder: "https://domain.com",
        },
        {
          type: "selectbox",
          name: "openLink",
          label: "Open link in...",
          items: [
            { value: "_self", text: "Same window tab" },
            { value: "_blank", text: "New window tab" },
          ],
        },
      ],
    },
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "submit",
        name: "submit",
        text: "Add",
        primary: true,
      },
    ],
    onSubmit: api => {
      const data = api.getData();
      const parentElement = tinymce.activeEditor.selection.getNode().nodeName.toLowerCase();

      const templateToAdd = getCTAOuterTemplate({
        url: data.url,
        text: data.text,
        tab: data.openLink,
      });

      const shortcodeWrapper = getShortcodeWrapper(uuid, shortcodeOnClick, templateToAdd);
      addShortcodeToEditor(shortcodeWrapper, uuid, parentElement);
      api.close();
    },
  });
};

export { ctaOuterConfig };
